module.exports = __webpack_public_path__ + "media/images/form_radio_checked-d9ed9123716f8bc1bc4cbc9909645d06.png";